import { ProviderProfileCard } from "../online-doctor/ProviderProfileCard"
import { WebsiteProvider } from "@components/preact/hooks/useProvidersWebsite"

const Skeleton = () => {
  return (
    <div className="w-72 h-96 p-6 bg-white rounded-2xl border border-neutral-20 flex flex-col items-start animate-pulse">
      <div className="flex flex-col gap-y-6 w-full">
        <div className="w-28 h-28 rounded-full bg-neutral-20" />
        <div className="flex flex-col gap-y-1 w-full">
          <div className="h-6 w-full rounded-sm bg-neutral-20" />
          <div className="flex items-center gap-1 mt-1">
            <div className="w-5 h-5 rounded bg-neutral-20 shrink-0" />
            <div className="h-4 w-10 rounded-sm bg-neutral-20" />
            <div className="h-4 w-20 rounded-sm bg-neutral-20" />
          </div>
          <div className="flex items-center gap-1 mt-2 w-full">
            <div className="w-5 h-5 rounded bg-neutral-20 shrink-0 mt-0.5" />
            <div className="h-4 flex-1 rounded-sm bg-neutral-20" />
          </div>
          <div className="flex items-center gap-1 mt-2 w-full">
            <div className="w-5 h-5 rounded bg-neutral-20 shrink-0 mt-0.5" />
            <div className="h-4 flex-1 rounded-sm bg-neutral-20" />
          </div>
        </div>
      </div>
    </div>
  )
}

const ProviderCard = ({
  providerWebsite,
}: {
  providerWebsite: WebsiteProvider
}) => {
  return (
    <a
      className="w-72 h-full px-6 py-8 bg-white rounded-2xl border border-neutral-20 flex flex-col items-start min-h-96 "
      href={`https://booking-v2.circlemedical.com/provider/?slug=${providerWebsite.slug}`}
    >
      <ProviderProfileCard
        name={providerWebsite.name}
        profileImage={providerWebsite.profileImage120X120}
        title={providerWebsite.title}
        ratingScore={parseFloat(providerWebsite.ratingScore)}
        ratingsCount={providerWebsite.ratingsCount}
        specialty={providerWebsite.specialty}
        yearsOfExperience={providerWebsite.yearsOfExperience}
        layout="vertical"
      />
    </a>
  )
}
ProviderCard.Skeleton = Skeleton
export default ProviderCard
